"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const RepetitionType_1 = __importDefault(require("@opsbase/lib-time/RepetitionType/RepetitionType"));
const createCustomRepetition_1 = __importDefault(require("@opsbase/lib-time/helpers/createCustomRepetition"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
/**
 * Schedule
 */
class WorkflowSchedule {
    /* CONSTRUCTOR */
    constructor(o = {}) {
        this.repetitionType = RepetitionType_1.default.WEEKLY;
        this.customRepetition = (0, createCustomRepetition_1.default)();
        this.dueDate = o.dueDate || (0, moment_timezone_1.default)();
        this.repetitionType = o.repetitionType || RepetitionType_1.default.WEEKLY;
        this.customRepetition = o.customRepetition || (0, createCustomRepetition_1.default)();
    }
}
exports.default = WorkflowSchedule;
